'use strict'

var glslify = require('glslify')

exports.boxVertex = glslify('./shaders/box-vertex.glsl')
exports.boxFragment = glslify('./shaders/box-fragment.glsl')



//////////////////
// WEBPACK FOOTER
// ./node_modules/gl-select-box/lib/shaders.js
// module id = DGFK
// module chunks = 0